var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui center aligned container"},[(_vm.image)?_c('div',{directives:[{name:"viewer",rawName:"v-viewer",value:(_vm.options),expression:"options"}],staticClass:"ui images"},[_c('img',{attrs:{"src":'https://static.ycyup.cn/mw690/' + _vm.image,"data-src":'https://static.ycyup.cn/large/' + _vm.image}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }